// extracted by mini-css-extract-plugin
export default {"header":"style--header--093b49"};